function formatDkIban(input) {
    var slicedPart = input.slice(4)
    var prefix = slicedPart.slice(0, 4)
    var suffix = slicedPart.slice(4)
    return prefix + '-' + suffix
}

function formatIban(input, currencyCode) {
    if (!input) {
        return ''
    }

    if (!currencyCode || currencyCode === 'DKK') {
        return formatDkIban(input)
    }

    return input
}

module.exports = formatIban
